module.exports = __webpack_public_path__ + "static/media/mshtml_32535.c093d7b4.ico";